import { UseFormRegister } from "react-hook-form";
import * as S from "./Inputs.style";

export interface InputsProps {
  type?: "text" | "password";
  label?: string;
  children?: React.ReactNode;
  placeholder?: string;
  direction?: "row" | "column";
  register?: any;
  value?: any;
  required?: boolean;
  color?: any;
  errors?: any;
  success?: any;
}

export const Inputs = ({
  label,
  children,
  direction = "column",
  required = false,
  color,
  errors,
  success,
}: InputsProps) => {
  return (
    <S.InputBox $direction={direction} $color={color}>
      {label && (
        <S.InputLabel $direction={direction} $color={color}>
          {label} {required === true && <span>*</span>}
        </S.InputLabel>
      )}
      {children}
      {/* 에러 텍스트 표기 */}
      <S.ErroredText $errored={errors ? true : false}>
        {errors ? errors : success}
      </S.ErroredText>
    </S.InputBox>
  );
};
